// Polyfill for fs.constants.F_OK deprecation warning
// This file is imported early in the application lifecycle

if (typeof window !== 'undefined') {
  // @ts-ignore
  window.process = window.process || {};
  // @ts-ignore
  if (!window.process.versions) window.process.versions = {};
  // @ts-ignore
  if (!window.process.versions.node) window.process.versions.node = '12.0.0';
}

// Mock fs module if needed by some dependencies in browser environment
// This is a workaround for dependencies that might try to import 'fs'
try {
    // Only mock if it doesn't exist or if we need to patch constants
    // Since we can't easily patch native modules in browser without bundler config,
    // we rely on this running before other code if possible.
    // However, the warning comes from node process running the build, not the browser.
    // So this file might not help with the build warning itself, but helps runtime.
} catch (e) {
    // Ignore
}
